import { match } from 'path-to-regexp';

const DEFAULT_PATH: Readonly<string> = '/login';

export const getRedirectionPath = (pathsDictionary: Record<string, string>, path: string): string => {
  const pathKeys = Object.keys(pathsDictionary);
  const matchRoute = pathKeys.find(candidate => match(candidate)(path));
  if (matchRoute && pathsDictionary[matchRoute]) {
    return pathsDictionary[matchRoute];
  }
  return DEFAULT_PATH;
};
